import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import { IApiListParams } from '@/types/api';
import { IWlBalanceApiListResponse } from '@/types/wlBalance';

export const wlBalanceList = (params: IApiListParams, config?: AxiosRequestConfig): Promise<AxiosResponse<IWlBalanceApiListResponse>> => {
    return axios.get('/api/wlbalance/list', { ...config, params });
};

export const wlBalanceExport = (params: IApiListParams): Promise<AxiosResponse<Blob>> => {
    return axios.get('/api/wlbalance/export', { params, responseType: 'blob' });
};
